export interface ChangePasswordField {
  old_password: string;
  new_password: string;
}

export interface RoleTableProps {
  // userList: userList[];
  loading: boolean;
}

export interface RoleManagementTableProps {
  // userList: userList[];
  loading: boolean;
  open: () => void;
}

export interface FacilityDataPropsType {
  avatar: string;
  created_at: string;
  email: string;
  facilityId: string;
  facility_size: string;
  facility_type: string;
  freeze: boolean;
  isSignupCompleted: boolean;
  isVerified: boolean;
  lastLogin: string;
  level: number;
  name: string;
  role: string;
  suspended: boolean;
  tag: {
    admin: any;
    note: string;
    status: boolean;
    taggedAt: any;
  };
  type: string;
  updated_at: string;
  verification: string;
  _id: string;
  state: string;
  reg_no: string;
  other_registration_number: string;
  city: string;
  address: string;
  phone_number: string;
  contact_name: string;
  contact_email: string;
  contact_job_title: string;
  specialties: string;
  locationDetails?: {
    address: string;
    latitude: number | string;
    longitude: number | string;
    city?: string;
    state?: string;
    country?: string;
  };
}

export const FacilityDataPropsTypeDummy = {
  avatar: "",
  created_at: "",
  email: "",
  facilityId: "",
  facility_size: "",
  facility_type: "",
  freeze: false,
  isSignupCompleted: false,
  isVerified: false,
  lastLogin: "",
  level: 0,
  name: "",
  role: "",
  suspended: false,
  tag: {
    admin: null,
    note: "",
    status: false,
    taggedAt: null,
  },
  type: "",
  updated_at: "",
  verification: "",
  _id: "",
  state: "",
  reg_no: "",
  other_registration_number: "",
  city:  "",
  address:  "",
  phone_number:  "",
  contact_name:  "",
  contact_email: "",
  contact_job_title:  "",
  specialties:  "",
  locationDetails: undefined,
};
